module.exports = __webpack_public_path__ + "static/author-2-87a75ca561b3ac98c7c00764c588eb89.jpg";